"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBaseFieldProposals = void 0;
const lodash_1 = __importDefault(require("lodash"));
const createBaseFieldProposals = ({ baseFields, usePrefix = false, }) => {
    return lodash_1.default.map(baseFields, ({ field, type }) => {
        return {
            label: `baseFields.${field}`,
            documentation: type,
            insertText: usePrefix ? `baseFields.${field}` : field,
        };
    });
};
exports.createBaseFieldProposals = createBaseFieldProposals;
//# sourceMappingURL=baseFields.js.map